import { css } from "@styled-system/css";
import { stack } from "@styled-system/patterns";

export const learnTrackingListClass = stack({ gap: "8" });
export const headingClass = css({ mt: "24", mb: "32" });
